import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CategoryEnum, DownTimePlannedCategoryenum, DownTimeTrackingStatusEnum } from '@gtpl/shared-models/common-models';

export class DowntimeTrackingDto {
  @ApiProperty()
  @IsNotEmpty({ message: "DowntimeTrackingId should not be empty" })
  @IsAlphanumeric()
  @IsOptional()
  downtimeTrackingId: number;

  @ApiProperty()
  // @IsNotEmpty({ message: "DepartmentId should not be empty" })
  @IsAlphanumeric()
  @IsOptional()
  departmentId: number;

  @ApiProperty()
  @IsNotEmpty({ message: "Category should not be empty" })
  @IsAlphanumeric()
  @IsOptional()
  category: CategoryEnum;

  @ApiProperty()
  startTime: Date;

  @ApiProperty()
  reasonId: number;

  @ApiProperty()
  assetId:number;

  @ApiProperty()
  @IsNumber()
  resources: number;

  @ApiProperty()
  @IsNotEmpty()
  status: DownTimeTrackingStatusEnum;

  @ApiProperty()
  endtime: Date;

  @ApiProperty()
  impact: string;

  @ApiProperty()
  remarks: string;

  @ApiProperty()
  saleorderId: number;

  @ApiProperty()
  machineName: string;

  @ApiProperty()
  employeeId: number;

  @ApiProperty()
  isActive: boolean;
  createdAt: Date;

  @ApiProperty()
  @IsNotEmpty()
  downtimetype: DownTimePlannedCategoryenum;

  @ApiProperty()
  plannedtime: Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
  createdUser: string;

  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
  updatedUser: string;

  @ApiProperty()
  unitId:number;
  
  @ApiProperty()
  machineCode:string;

  @ApiProperty()
  resolution:string;
  
  @ApiProperty()
  versionFlag: number;

  @ApiProperty()
  reason: string;

  @ApiProperty()
  sla?: number;

  @ApiProperty()
  duration?: Date;

  @ApiProperty()
  diffhours?: Date;

  @ApiProperty()
  departmentname?: string;

  @ApiProperty()
  hours?: Date;

  @ApiProperty()
  employeeName?:string;

@ApiProperty()
assetCategoryId:number;
}